import { Box } from '@mui/material';

import { WorkflowHistoryEntry } from '../../../types';

type Props = {
  workflowHistory: WorkflowHistoryEntry[];
  showHistory: boolean;
  fieldKey: keyof WorkflowHistoryEntry;
};

export const HistoryCell = (props: Props) => {
  const { workflowHistory, showHistory, fieldKey } = props;

  if (showHistory && workflowHistory.length > 1) {
    return (
      <Box>
        {workflowHistory.map((entry, index) => (
          <Box key={index}>{entry[fieldKey]}</Box>
        ))}
      </Box>
    );
  }

  return <Box>{workflowHistory[0][fieldKey]}</Box>;
};
